import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { NavMenuComponent } from "./navmenu.component";

@NgModule({
  declarations: [NavMenuComponent],
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  exports: [NavMenuComponent],
})
export class NavMenuModule {}
